import React, { Fragment, useCallback, useEffect, useReducer } from "react";
import ReactModal from "react-modal";
import { useHistory, Prompt } from "react-router-dom";

const reducer = (state, action) => {
  switch (action.type) {
    case "openModal": {
      return {
        ...state,
        showModal: true,
        nextLocation: action.nextLocation,
      };
    }
    case "closeModal": {
      return {
        ...state,
        showModal: false,
        isConfirmed: action.isConfirmed || false,
      };
    }
    case "reset": {
      return {
        ...state,
        showModal: false,
        nextLocation: null,
        isConfirmed: false,
      };
    }
    default:
      return state;
  }
};

const UnsavedChangesWarningModal = ({ isChanged }) => {
  const initialState = {
    showModal: false,
    nextLocation: null,
    isConfirmed: false,
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const history = useHistory();

  useEffect(() => {
    const unloadCallback = (event) => {
      event.preventDefault();
      event.returnValue = "";

      return "";
    };

    if (isChanged) {
      window.addEventListener("beforeunload", unloadCallback);
    } else {
      window.removeEventListener("beforeunload", unloadCallback);
    }

    return () => {
      window.removeEventListener("beforeunload", unloadCallback);
    }
  }, [isChanged]);

  useEffect(() => {
    if (state.isConfirmed) {
      dispatch({
        type: "reset",
      });
      history.push(state.nextLocation);
    }
  }, [state.isConfirmed, state.nextLocation, history, dispatch]);

  const handleCloseModal = useCallback(() => {
    dispatch({
      type: "closeModal",
    });
  }, []);

  const handleConfirm = useCallback(() => {
    dispatch({
      type: "closeModal",
      isConfirmed: true,
    });
  }, []);

  const handleBlockedNavigation = useCallback((nextLocation) => {
    if (!state.isConfirmed) {
      dispatch({
        type: "openModal",
        nextLocation,
      });

      return false;
    }

    return true;
  }, [state.isConfirmed]);

  return (
    <Fragment>
      <Prompt
        when={isChanged}
        message={handleBlockedNavigation}
      />

      <ReactModal
        isOpen={state.showModal}
        shouldCloseOnEsc={false}
        shouldCloseOnOverlayClick={false}
        onRequestClose={handleCloseModal}
        style={{
          overlay: {
            zIndex: 1000000,
            backgroundColor: "rgb(32 53 68 / 50%)",
          },
          content: {
            width: "auto",
            padding: "40px",
            border: "none",
            maxWidth: "700px",
            maxHeight: "50%",
            borderRadius: "0",
            boxShadow: "10px 10px 91px -17px rgb(0 0 0 / 25%)",
          },
        }}
        appElement={document.getElementById("app")}
      >
        <div className="modal-header base-modal">
          <h4>Changes Not Saved</h4>
        </div>

        <div className="modal-body base-modal overflow-scroll">
          <div className="w-100 mt-20">
            You've made changes that haven’t been saved. Leaving now will discard them.
          </div>

          <div className="w-100 mt-20 d-flex gap-20">
            <button className="base-button evo-blue flex-half" type="button" onClick={handleCloseModal}>
              Keep Editing
            </button>

            <button className="base-button btn-danger flex-half" type="button" onClick={handleConfirm}>
              Leave Anyway
            </button>
          </div>
        </div>
      </ReactModal>
    </Fragment>
  );
};

export default UnsavedChangesWarningModal;
